var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import { useEffect, useState } from "react";
import { StarList } from "./common/StarList";
import { showError, translate } from "@js/common/helpers";
import { collectionRatingApi } from "../api";
import { CollectionRating } from "../../types";
import { initAuth } from "@js/common/auth/modalHandler";
import { AuthFirstNameLastNameModal } from "../../modals/AuthFirstNameLastNameModal";
import { useRating } from "../hooks/useRating";
import { Textarea } from "./common/Textarea";
import { Statuses } from "../enums";
var Form = function (_a) {
    var afterRatingCreated = _a.afterRatingCreated, user = _a.user, enabledRatingsCount = _a.enabledRatingsCount;
    var _b = useState(new CollectionRating()), rating = _b[0], setRating = _b[1];
    var _c = useState(false), isError = _c[0], setIsError = _c[1];
    var _d = useState(false), showAuthNameModal = _d[0], setShowAuthNameModal = _d[1];
    var _e = useRating(), getCurrentCollectionSlug = _e.getCurrentCollectionSlug, getUser = _e.getUser;
    useEffect(function () {
        var savedNote = localStorage.getItem('rating');
        var savedComment = localStorage.getItem('comment');
        var ratingCollectionSlug = localStorage.getItem('rating_collection_slug');
        if (savedNote && getCurrentCollectionSlug() === ratingCollectionSlug) {
            handleStarNumberChange(parseInt(savedNote));
        }
        if (savedComment && getCurrentCollectionSlug() === ratingCollectionSlug) {
            handleAfterCommentChange(savedComment);
        }
    }, []);
    var handleStarNumberChange = function (note) {
        setIsError(false);
        setRating(function (prevRating) { return (__assign(__assign({}, prevRating), { note: note })); });
    };
    var handleAfterCommentChange = function (comment) {
        setIsError(false);
        setRating(function (prevRating) { return (__assign(__assign({}, prevRating), { comment: comment, status: comment.trim().length > 0 ? Statuses.Pending : Statuses.Enabled })); });
    };
    var handleSubmit = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var refetchedUser, updatedRating, created, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event === null || event === void 0 ? void 0 : event.preventDefault();
                    if ((rating === null || rating === void 0 ? void 0 : rating.note) === 0) {
                        setIsError(true);
                        return [2];
                    }
                    if (user.logged === false) {
                        initAuth('collection_rating');
                        localStorage.setItem('rating', rating.note.toString());
                        localStorage.setItem('comment', rating.comment.toString());
                        localStorage.setItem('rating_collection_slug', getCurrentCollectionSlug());
                        return [2];
                    }
                    return [4, getUser()];
                case 1:
                    refetchedUser = _a.sent();
                    if (refetchedUser && (!refetchedUser.firstname || !refetchedUser.lastname)) {
                        setShowAuthNameModal(true);
                        return [2];
                    }
                    updatedRating = __assign(__assign({}, rating), { userUuid: refetchedUser.uuid, collectionSlug: getCurrentCollectionSlug() });
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4, collectionRatingApi.create(updatedRating)];
                case 3:
                    created = _a.sent();
                    if (!created) {
                        showError('collection_rating.form.error.global');
                        return [2];
                    }
                    if (typeof afterRatingCreated === 'function') {
                        afterRatingCreated(rating.comment);
                    }
                    return [3, 5];
                case 4:
                    error_1 = _a.sent();
                    showError('collection_rating.form.error.global');
                    return [3, 5];
                case 5: return [2];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: "ratingForm" },
            React.createElement("h5", null, enabledRatingsCount > 0 ? translate('collection_rating.form.title.global') : translate('collection_rating.form.title.first_rating')),
            React.createElement("form", { onSubmit: handleSubmit },
                React.createElement("div", null,
                    React.createElement(StarList, { afterStarNumberChange: handleStarNumberChange, note: rating.note, isError: isError, isClickable: true }),
                    isError
                        ? (rating.comment === ''
                            ? React.createElement("p", { className: "error" }, translate('collection_rating.form.error.stars_empty'))
                            :
                                React.createElement("p", { className: "error" }, translate('collection_rating.form.error.stars_empty_comment_exists')))
                        : null,
                    React.createElement(Textarea, { afterCommentChange: handleAfterCommentChange, rating: rating })),
                React.createElement("button", { className: "btn btn-primary" }, translate('submit')))),
        showAuthNameModal && React.createElement(AuthFirstNameLastNameModal, { user: user, afterNameSubmit: handleSubmit })));
};
export { Form };
